var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Agent Handover/Return")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "handover-option"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-12"
  }, [_c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changePage == '1' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changePage),
      expression: "changePage"
    }],
    attrs: {
      "type": "radio",
      "id": "changePage",
      "name": "changePage"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.changePage, 1)
    },
    on: {
      "click": _vm.clearAllFields,
      "change": function($event) {
        _vm.changePage = 1
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Handover to Agent ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text scan-tally-button btn-sm btn-primary",
    class: _vm.changePage == '0' ? '' : 'active'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changePage),
      expression: "changePage"
    }],
    attrs: {
      "type": "radio",
      "id": "changePage",
      "name": "changePage"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.changePage, 0)
    },
    on: {
      "click": _vm.clearAllFields,
      "change": function($event) {
        _vm.changePage = 0
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Return InScan ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changePage == 1),
      expression: "changePage == 1"
    }],
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm1('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Handover Agent")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.superagentsarray,
      "selected-option": _vm.agentitem,
      "placeholder": "Select Agent",
      "name": "Agent",
      "id": "Agent"
    },
    on: {
      "select": _vm.SelectAgent
    },
    model: {
      value: (_vm.Agent),
      callback: function($$v) {
        _vm.Agent = $$v
      },
      expression: "Agent"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Agent')),
      expression: "errors.has('form-1.Agent')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Select Handover Agent.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" Job Type ")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.JobType),
      expression: "JobType"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('JobType')
    },
    attrs: {
      "name": "JobType",
      "id": "JobType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.JobType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeJobTypeEvent]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select JobType")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Delivery"
    }
  }, [_vm._v("Ecomm - Forward - Delivery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO"
    }
  }, [_vm._v("Ecomm - Forward - RTO ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DTO"
    }
  }, [_vm._v("Ecomm - Reverse - Delivery(DTO) ")]), _vm._v(" "), (_vm.isRVPFeataureEnableForTesting) ? _c('option', {
    attrs: {
      "value": "RVP"
    }
  }, [_vm._v("Ecomm - Reverse - Pickup(RVP) ")]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.JobType != 'RVP') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Handover Mode")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handovermode),
      expression: "handovermode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('handovermode')
    },
    attrs: {
      "name": "HandoverMode",
      "id": "handovermode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.handovermode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Handover Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Handcarry"
    }
  }, [_vm._v("Handcarry")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vehicle"
    }
  }, [_vm._v("Vehicle")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.HandoverMode')),
      expression: "errors.has('form-1.HandoverMode')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Select Handover Mode.")])]) : _vm._e(), _vm._v(" "), (_vm.JobType != 'RVP') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleno),
      expression: "vehicleno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/
      }),
      expression: "{ required: true, regex: /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/ }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Number",
      "name": "vehicleno",
      "id": "vehicleno"
    },
    domProps: {
      "value": (_vm.vehicleno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleno = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.vehicleno')),
      expression: "errors.has('form-1.vehicleno')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Enter Valid Vehicle Number.")]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])]) : _vm._e(), _vm._v(" "), (_vm.JobType != 'RVP') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Handover Person Name")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handoverpersonname),
      expression: "handoverpersonname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Handover Person Name",
      "name": "handoverpersonname",
      "id": "handoverpersonname"
    },
    domProps: {
      "value": (_vm.handoverpersonname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handoverpersonname = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.handoverpersonname')),
      expression: "errors.has('form-1.handoverpersonname')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please enter Handover Person name.")])]) : _vm._e(), _vm._v(" "), (_vm.JobType != 'RVP') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipping IDs")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingId),
      expression: "ShippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormatforAdmin1'),
      expression: "'required|VerifyShippingidFormatforAdmin1'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "ShippingId",
      "id": "ShippingId"
    },
    domProps: {
      "value": (_vm.ShippingId)
    },
    on: {
      "keypress": _vm.KeycheckFunction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingId = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingId')),
      expression: "errors.has('form-1.ShippingId')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.ShippingId')))]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\n      Multiple shipping IDs can be separated using comma or  next line (↵/,).")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4",
    staticStyle: {
      "margin-left": "150px"
    }
  }, [_c('dummy-input', {
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "formSubmit",
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Transfer")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm1
    }
  }, [_vm._v("\n                        Reset\n                      ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isHandoverLoader,
      "text": "Please wait shipments is handover to agent in processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isHandoverLoader = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "RVP Allocated Shipment",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeRvpSuggestShipmentsModel
    },
    model: {
      value: (_vm.morePendingRVPShipmentsModel),
      callback: function($$v) {
        _vm.morePendingRVPShipmentsModel = $$v
      },
      expression: "morePendingRVPShipmentsModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP Allocated Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRvpSuggestShipmentsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.morePendingRVPShipmentsModel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v("Below Shipments are from same customer, Please Handover them to same Agent. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.rvpHandoverShipment()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeRvpSuggestShipmentsModel()
      }
    }
  }, [_vm._v(" Cancel")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isHandoverLoader,
      "text": "Please wait shipments is handover to agent in processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isHandoverLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAllMoreShip),
      expression: "sAllMoreShip"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAllMoreShip) ? _vm._i(_vm.sAllMoreShip, "") > -1 : (_vm.sAllMoreShip)
    },
    on: {
      "click": function($event) {
        return _vm.selectAllMoreRVPShipments($event)
      },
      "change": function($event) {
        var $$a = _vm.sAllMoreShip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAllMoreShip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAllMoreShip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAllMoreShip = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.suggestRVPArrayList), function(row, index) {
    return _c('tr', {
      attrs: {
        "id": 'rvpTrMr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedReverseChildShipmentData),
        expression: "selectedReverseChildShipmentData"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": "selectedPickupsMore"
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedReverseChildShipmentData) ? _vm._i(_vm.selectedReverseChildShipmentData, row.ShippingId) > -1 : (_vm.selectedReverseChildShipmentData)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedReverseChildShipmentData,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedReverseChildShipmentData = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedReverseChildShipmentData = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedReverseChildShipmentData = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CIMr' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pendingShipmentForDeliveryobj.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])])], 1)])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changePage == 0),
      expression: "changePage == 0"
    }],
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm2('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Process")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.process),
      expression: "process"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('handovermode')
    },
    attrs: {
      "name": "process",
      "id": "process"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.process = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.ChangeLabelName]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Process")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "InScan"
    }
  }, [_vm._v("InScan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shortage"
    }
  }, [_vm._v("Shortage")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.process')),
      expression: "errors.has('form-2.process')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v("Please Select Process.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-4"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipping IDs")])]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awb),
      expression: "awb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|VerifyShippingidFormatforAdmin2'),
      expression: "'required|VerifyShippingidFormatforAdmin2'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "awb",
      "id": "awb"
    },
    domProps: {
      "value": (_vm.awb)
    },
    on: {
      "keypress": _vm.KeycheckFunction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awb = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.awb')),
      expression: "errors.has('form-2.awb')"
    }],
    staticClass: "text-danger error-position"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.awb')))]), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-8"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\n      Multiple shipping IDs can be separated using comma or  next line (↵/,).")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-4",
    staticStyle: {
      "margin-left": "150px"
    }
  }, [_c('dummy-input', {
    ref: "dummyShipInputBox",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.buttonLabel))]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm2
    }
  }, [_vm._v("\n                      Reset\n                    ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isInScanReturnLoader,
      "text": "Shipment return inscan is processing..."
    },
    on: {
      "update:active": function($event) {
        _vm.isInScanReturnLoader = $event
      }
    }
  })], 1)])])])], 1)]), _vm._v(" "), (_vm.changePage == 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [(_vm.JobType != 'RVP') ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.viewFullScreenModel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Available for Transfer",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingShipments(true)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPendingShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                        "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalPendingShipmentforDeliverycnt) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentKeySearchById),
      expression: "shipmentKeySearchById"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentKeySearchById')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "shipmentKeySearchById"
    },
    domProps: {
      "value": (_vm.shipmentKeySearchById)
    },
    on: {
      "keydown": _vm.searchAllPendingShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentKeySearchById = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": _vm.searchAllPendingShipmentsonButtonEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)])], 1), _vm._v("  \n                          "), _c('pending-shipments', {
    ref: "PendingShipments",
    attrs: {
      "JobType": _vm.JobType,
      "isPendingShipmentforDeliveryLoader": _vm.isPendingShipmentforDeliveryLoader,
      "totalPendingShipmentforDeliverycnt": _vm.totalPendingShipmentforDeliverycnt,
      "pageCount": _vm.pageCount,
      "pendingShipmentForDeliveryobj": _vm.pendingShipmentForDeliveryobj
    },
    on: {
      "getSelectedShipments": _vm.getSelectedShipments,
      "getPaginationDataChild": _vm.getPaginationData
    }
  })], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transferred to Agent",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.TransferredShipmentToAgentList(true)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadPendingShipmentList('reload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                        "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v("Count - " + _vm._s(_vm.totalHandoverShipmentcnt) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentKeySearchById),
      expression: "shipmentKeySearchById"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentKeySearchById')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "shipmentKeySearchById"
    },
    domProps: {
      "value": (_vm.shipmentKeySearchById)
    },
    on: {
      "keydown": _vm.searchAllPendingShipments,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentKeySearchById = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.TransferredShipmentToAgentList(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)])], 1), _vm._v("  \n                        "), _c('handover-shipment', {
    ref: "handoverShipments",
    attrs: {
      "isHandoverShipmentListLoader": _vm.isHandoverShipmentListLoader,
      "totalHandoverShipmentcnt": _vm.totalHandoverShipmentcnt,
      "pageCount1": _vm.HandoverpageCount,
      "HandoverShipmentList": _vm.HandoverShipmentList,
      "isRemoveOption": _vm.isRemoveOption
    },
    on: {
      "removeHandoverShipment": _vm.removeHandoverShipment,
      "getHandoverPaginationDataChild": _vm.getHandoverPaginationData
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.ActiveTabIndex == 0 ? 'Available For Transfer List' : 'Transferred to Agent'))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.ActiveTabIndex == 0) ? _c('pending-shipments', {
    ref: "PendingShipments",
    attrs: {
      "JobType": _vm.JobType,
      "isPendingShipmentforDeliveryLoader": _vm.isPendingShipmentforDeliveryLoader,
      "totalPendingShipmentforDeliverycnt": _vm.totalPendingShipmentforDeliverycnt,
      "pageCount": _vm.pageCount,
      "pendingShipmentForDeliveryobj": _vm.pendingShipmentForDeliveryobj
    },
    on: {
      "getPaginationDataChild": _vm.getPaginationData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ActiveTabIndex == 1) ? _c('handover-shipment', {
    ref: "handoverShipments",
    attrs: {
      "isHandoverShipmentListLoader": _vm.isHandoverShipmentListLoader,
      "HandoverShipmentList": _vm.HandoverShipmentList,
      "totalHandoverShipmentcnt": _vm.totalHandoverShipmentcnt,
      "pageCount1": _vm.HandoverpageCount
    },
    on: {
      "getHandoverPaginationDataChild": _vm.getHandoverPaginationData
    }
  }) : _vm._e()], 1)])])])])])])], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "enlarge-css"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.openModal(_vm.primaryType)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 tabs-active"
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.returnInScanBTabs),
      callback: function($$v) {
        _vm.returnInScanBTabs = $$v
      },
      expression: "returnInScanBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "SVC Inscan Pending",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabs('SVCInscanPending', 'Forward')
      }
    }
  }, [_c('b-tabs', {
    staticClass: "tabs-active-style sub-Tabs-style",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.svcInScanPendingBTabs),
      callback: function($$v) {
        _vm.svcInScanPendingBTabs = $$v
      },
      expression: "svcInScanPendingBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery"
    },
    on: {
      "click": function($event) {
        return _vm.switchTabs('SVCInscanPending', 'Forward')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO"
    },
    on: {
      "click": function($event) {
        return _vm.switchTabs('SVCInscanPending', 'RTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO"
    },
    on: {
      "click": function($event) {
        return _vm.switchTabs('SVCInscanPending', 'DTO')
      }
    }
  })], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingList,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadReturnInScanTab('SVCInscanPending')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload svc inscan pending"
    }
  })]), _vm._v("  \n                              "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalPendingShipments) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "id": "Shipping_Id",
      "name": "ShippingId"
    },
    model: {
      value: (_vm.svcPendingSearchById),
      callback: function($$v) {
        _vm.svcPendingSearchById = $$v
      },
      expression: "svcPendingSearchById"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentsData('SVCInscanPending', _vm.shipmentType)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1)]), _vm._v(" "), _c('svcInScan-Pending', {
    attrs: {
      "isCourierCompanyId": _vm.isCourierId,
      "svcInScanPendingList": _vm.shipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    ref: "paginateRefs1",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending For Return",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabs('SAReturnPending', 'Reverse')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingList,
      "text": "Please Wait Loading Shipments..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingList = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row mb-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadReturnInScanTab('SAReturnPending')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload svc inscan pending"
    }
  })]), _vm._v("  \n                              "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalPendingShipments) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingForReturnSearchById),
      expression: "pendingForReturnSearchById"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shippingid')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "id": "Shippingid",
      "name": "Shippingid"
    },
    domProps: {
      "value": (_vm.pendingForReturnSearchById)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingForReturnSearchById = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentsData('SAReturnPending', 'Reverse')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)])], 1)]), _vm._v(" "), _c('shortage-Shipments', {
    attrs: {
      "isCourierCompanyId": _vm.isCourierId,
      "shortagePendingShipments": _vm.shipmentList
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginate),
      expression: "showPaginate"
    }],
    ref: "paginateRefs2",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "SVC InScan Pending"
    },
    model: {
      value: (_vm.mdlSVCInScanPending),
      callback: function($$v) {
        _vm.mdlSVCInScanPending = $$v
      },
      expression: "mdlSVCInScanPending"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("SVC InScan Pending")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SVCInscanPending')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModel
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModel = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-tabs', {
    staticClass: "sub-Tabs-style shipmentListtab",
    staticStyle: {
      "border": "1px solid #cecece !important"
    },
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.mdlSVCInScanPendingBTabs),
      callback: function($$v) {
        _vm.mdlSVCInScanPendingBTabs = $$v
      },
      expression: "mdlSVCInScanPendingBTabs"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Delivery",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModel('SVCInscanPending', 'Forward')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "DTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModel('SVCInscanPending', 'DTO')
      }
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "RTO",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.switchTabsModel('SVCInscanPending', 'RTO')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "mr-1",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadReturnInScanTab('SVC')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalPendingShipmentsModel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('Shippingid')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdSvcInScanPendingMdl",
      "placeholder": "Enter Shipping Id",
      "name": "Shippingid"
    },
    model: {
      value: (_vm.shippingIdSvcInScanPendingMdl),
      callback: function($$v) {
        _vm.shippingIdSvcInScanPendingMdl = $$v
      },
      expression: "shippingIdSvcInScanPendingMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentsDataModel('SVCInscanPending', _vm.shipmentTypeModel)
      }
    }
  }, [_vm._v(" Search")])])], 1)], 1)], 1)])])]), _vm._v(" "), _c('svcInScan-Pending', {
    attrs: {
      "isCourierCompanyId": _vm.isCourierId,
      "svcInScanPendingList": _vm.shipmentListModel
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginateModel),
      expression: "showPaginateModel"
    }],
    ref: "paginateRefsMdl1",
    attrs: {
      "page-count": _vm.pageCountModel,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SVCInscanPending')
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Pending For Return"
    },
    model: {
      value: (_vm.mdlPendingForReturn),
      callback: function($$v) {
        _vm.mdlPendingForReturn = $$v
      },
      expression: "mdlPendingForReturn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending For Return")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SAReturnPending')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingModel
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingModel = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-between",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticClass: "mx-2",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "22px",
      "color": "#151B31"
    },
    on: {
      "click": function($event) {
        return _vm.reloadReturnInScanTab('SARP')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload Pending For Return List"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "20px",
      "color": "#151B31"
    }
  }, [_vm._v(" Count - " + _vm._s(_vm.totalPendingShipmentsModel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingID')
    },
    attrs: {
      "type": "text",
      "id": "ShippingIdPendingForReturnMdl",
      "placeholder": "Enter Shipping Id",
      "name": "ShippingID"
    },
    model: {
      value: (_vm.shippingIdPendingForReturnMdl),
      callback: function($$v) {
        _vm.shippingIdPendingForReturnMdl = $$v
      },
      expression: "shippingIdPendingForReturnMdl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "fa fa-search",
    staticStyle: {
      "height": "2.5em",
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getPendingShipmentsDataModel('SAReturnPending', 'Reverse')
      }
    }
  }, [_vm._v(" Search")])])], 1)], 1)], 1)])])]), _vm._v(" "), _c('shortage-Shipments', {
    attrs: {
      "isCourierCompanyId": _vm.isCourierId,
      "shortagePendingShipments": _vm.shipmentListModel
    }
  }), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaginateModel),
      expression: "showPaginateModel"
    }],
    ref: "paginateRefsMdl2",
    attrs: {
      "page-count": _vm.pageCountModel,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationShipmentListDataMdl,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('SAReturnPending')
      }
    }
  }, [_vm._v("Close")])])])])])], 1)])]), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0)) ? _c('b-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTable),
      expression: "showTable"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('legend', [_vm._v(" Agent Handover Process")]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.returnArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.message))])])
  }), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length == 0) || _vm.returnArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "17",
      "align": "center"
    }
  }, [_vm._v("No Data found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])], 1)])])]) : _vm._e()], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f73647a","hasScoped":false}!./src/views/components/agenthandover/agenthandover.component.html
// module id = 1041
// module chunks = 1